import { useState, useRef, useEffect } from "react";
import {
  FaComments,
  FaTimes,
  FaPaperPlane,
  FaUser,
  FaRobot
} from "react-icons/fa";

import "../styles/ChatBot.css";

import {
  defaultQuestions,
  getBotReply
} from "../utils/chatbot";

export default function ChatBot() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);

  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Hello 👋 Welcome to Justivon Assistant. How can I help you today?"
    }
  ]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = (customText) => {
    const text = customText || message;
    if (!text.trim()) return;

    setMessages((prev) => [...prev, { from: "user", text }]);

    setTimeout(() => {
      const reply = getBotReply(text);
      setMessages((prev) => [...prev, { from: "bot", text: reply }]);
    }, 350);

    setMessage("");
  };

  return (
    <>
      {/* Floating Button */}
      <div className="chatbot-float-btn" onClick={() => setOpen(true)}>
        <FaComments size={22} />
      </div>

      {open && (
        <div className="chatbot-container">

          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-title">
              <FaRobot />
              <span>Zara AI</span>
            </div>
            <button
              className="chatbot-close"
              onClick={() => setOpen(false)}
            >
              <FaTimes />
            </button>
          </div>

          {/* Messages */}
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`chatbot-message ${
                  msg.from === "user" ? "user" : "bot"
                }`}
              >
                <div className="chatbot-icon">
                  {msg.from === "user" ? <FaUser /> : <FaRobot />}
                </div>
                <div className="chatbot-text">{msg.text}</div>
              </div>
            ))}

            {/* Default quick queries */}
            {messages.length === 1 && (
              <div className="chatbot-quick-questions">
                {defaultQuestions.map((q, i) => (
                  <button key={i} onClick={() => sendMessage(q)}>
                    {q}
                  </button>
                ))}
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div className="chatbot-input-area">
            <input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />

            <button onClick={() => sendMessage()}>
              <FaPaperPlane />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
